// extracted by mini-css-extract-plugin
export default {"container":"icon-text_container__bvIQU"};